import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import classNames from 'classnames';
const DOT_COUNT = 3;
const DOT_ANIMATION_DURATION_MS = 1200;
const DOT_ANIMATION_DELAY_STEP_MS = 200;
const DOT_BASE_BACKGROUND = '#ffffff';
const DOT_BASE_SHADOW = 'inset 1px 1px 5px black';
const DOT_BRIGHT_BACKGROUND = '#a5a5a5';
const DOT_SIZE_CLASSES = {
    xs: 'ml-1 size-1.5',
    sm: 'ml-1.5 size-2',
    md: 'ml-2 size-3',
    lg: 'ml-2.5 size-4',
};
const MARGIN_RIGHT_CLASSES = {
    xs: 'mr-1',
    sm: 'mr-1.5',
    md: 'mr-2',
    lg: 'mr-2.5',
};
export default function DotsAnimation({ size, className }) {
    const containerRef = useRef(null);
    useEffect(() => {
        const containerElement = containerRef.current;
        if (!containerElement) {
            return;
        }
        const dotElements = Array.from(containerElement.children);
        const animations = dotElements.map((dotElement, dotIndex) => dotElement.animate([
            { backgroundColor: DOT_BASE_BACKGROUND, boxShadow: DOT_BASE_SHADOW },
            { backgroundColor: DOT_BRIGHT_BACKGROUND, boxShadow: 'none' },
        ], {
            duration: DOT_ANIMATION_DURATION_MS,
            delay: dotIndex * DOT_ANIMATION_DELAY_STEP_MS,
            iterations: Infinity,
            easing: 'ease',
        }));
        return () => {
            animations.forEach((animation) => animation.cancel());
        };
    }, []);
    const dotIndexes = Array.from({ length: DOT_COUNT }, (_value, index) => index);
    return (_jsx("div", { ref: containerRef, className: classNames('flex', className, MARGIN_RIGHT_CLASSES[size]), children: dotIndexes.map((dotIndex) => (_jsx("div", { className: classNames('rounded-full bg-white shadow-[inset_1px_1px_5px_black]', DOT_SIZE_CLASSES[size]) }, dotIndex))) }));
}
